
import { useTranslation } from "react-i18next";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { tryFind, ofList } from "../fable_modules/fable-library-js.5.0.0-rc.2/Map.js";
import { sortWith, map } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { countryFlag, locationCountries } from "../Shared/Location.js";
import { comparePrimitives } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { bind, defaultArg } from "../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { concat } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";

function useCountryNames() {
    const patternInput = useTranslation();
    const language = patternInput[1].language;
    const dependencies_1 = [language];
    return reactApi.useMemo(() => ofList(map((country) => [country.Code, (function (language, code) { try { return new Intl.DisplayNames([language], { type: 'region' }).of(code) || code; } catch (error) { return code; } })(language, country.Code.toUpperCase())], locationCountries), {
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    }), dependencies_1);
}

export function useCountryName() {
    const names = useCountryNames();
    return (code) => defaultArg(bind((code_1) => tryFind(code_1, names), code), "");
}

export function useCountryOptions() {
    let dependencies_1;
    const patternInput = useTranslation();
    const language = patternInput[1].language;
    const names = useCountryNames();
    const nameOf = (country) => defaultArg(tryFind(country.Code, names), country.Code);
    const option_1 = (country_1) => ({
        label: concat(countryFlag(country_1.Code), " ", ...nameOf(country_1)),
        value: country_1,
    });
    return [(dependencies_1 = [names], reactApi.useMemo(() => map(option_1, sortWith((left, right) => ((nameOf(left).localeCompare(nameOf(right), language)) | 0), locationCountries)), dependencies_1)), option_1];
}

